var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudiesBrain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 195 47.7",
    style: {
      enableBackground: "new 0 0 195 47.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.1,23.2c5.9,1.4,14.4,4.1,14.4,11.7c0,12-15.5,11.7-18.7,11.6L0,46.4v-1c7.8-1,7.8-3,8-9.6V13.4 C7.8,6.7,7.8,4.8,0.4,3.8v-1l13.1-0.5C20.8,2.1,33.6,2.8,33.6,13c0,6.3-6.3,8.8-11.5,10.1V23.2z M13.7,35.3c0,5-0.3,9.8,6.3,9.8 c5.6,0,9.6-3.7,9.6-9.4c0-3.9-3.7-11.8-13.3-11.3l-2.5,0.1V35.3z M13.7,23.2c6-0.1,13.5-1.7,13.5-9.2c0-7.8-6.9-10.2-13.5-10.2 V23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.4,15.8c0-9.9-0.3-11.4-7.6-12V2.8l15.8-0.5C68,1.8,69.3,9.8,69.3,12.9c0,5.4-3.4,8.5-8,10.6l0.3,0.5 c5,8.7,11.2,19.9,21.9,22.1l-0.1,0.4c-6.9-0.3-12,0.5-15.8-3.4c-4.3-4.5-7.6-10.2-9-12.9c-2.6-5.4-4.9-3.8-9.4-4.6v10.4 c0,7.1,0.1,8.4,9,9.6v1H35.4v-1c7.8-1,7.8-3,8-9.6V15.8z M49.1,24.3c6.2-0.1,13.5-2.9,13.5-10.1c0-7.6-6.7-10.6-13.5-10.5V24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.5,28c-1.1,3.2-3.9,10-3.9,13.1c0,3.9,4.5,3.9,7.4,4.4v1h-8.1l-8.6-0.2l-1-0.4v-0.4 c5.8-1.6,6.3-2.8,8.3-7.9l7.3-19.1L95.7,8c0.6-1.7,1.4-3.2,0.7-4.5c1.7-0.7,5-1.9,6.4-3.5l12.6,37.9c1.7,4.7,2.8,6.6,8,7.6v1h-19 v-1c2.3-0.5,5-1.2,5-4.1c0-2.7-2.5-8.8-4.1-13.3H90.5z M97.7,8.2L91.6,25h12.8L97.7,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137,35.8c0.2,6.7,0.3,8.6,8,9.6v1h-21.7v-1c7.8-1,7.8-3,8-9.6V13.1c-0.2-6.7-0.3-8.6-8-9.6v-1H145v1 c-7.8,1-7.8,3-8,9.6V35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.7,36.3l-0.3-23.6c-0.1-6.1-1.7-8-9.1-9.3v-1H195v1c-4.5,0.6-5.3,3-5.8,7.2c-0.9,7.1-0.6,22.7-0.3,36.8 l-0.8,0.2c-10.4-12.2-21.9-23.5-32.8-35.3v11.9c0,16-0.4,19.3,9,21.2v1h-19.3v-1c8.7-0.9,8.4-6.9,8.4-21.5v-9.7c0-6.5-1-9-9.3-10.8 v-1h10.7L186.7,36.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudiesBrain);
export default __webpack_public_path__ + "static/media/studies-BRAIN.1b2b27622a6859c8f5c2dc9a211dfa99.svg";
export { ForwardRef as ReactComponent };